<script setup>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@unhead/vue'
import AppShell from '@/components/layout/AppShell.vue'
import { trackVisit } from '@/utils/analytics'
import { trackAttribution } from '@/utils/attribution'

const route = useRoute()

const hideShell = computed(() => route.meta?.hideLayout === true)

onMounted(() => { trackVisit(); trackAttribution() })

useHead({
  titleTemplate: (title) => (title ? `${title} | Papersnap` : 'Papersnap | Snap a document. Get your data.'),
  script: [
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Keelara LLC',
        url: 'https://www.keelara.com',
        logo: 'https://www.papersnap.io/favicon.svg',
        sameAs: ['https://www.papersnap.io'],
      }),
    },
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebApplication',
        name: 'Papersnap',
        url: 'https://www.papersnap.io',
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Any',
        description: 'AI-powered document data extraction. Upload invoices, receipts, purchase orders, utility bills or financial reports and get clean structured data in JSON or CSV.',
        offers: [
          { '@type': 'Offer', name: 'Free', price: '0', priceCurrency: 'USD' },
          { '@type': 'Offer', name: 'Solo', price: '9', priceCurrency: 'USD' },
          { '@type': 'Offer', name: 'Business', price: '29', priceCurrency: 'USD' },
          { '@type': 'Offer', name: 'Enterprise', price: '99', priceCurrency: 'USD' },
        ],
      }),
    },
  ],
})
</script>

<template>
  <AppShell v-if="!hideShell">
    <RouterView />
  </AppShell>
  <RouterView v-else />
</template>
